import { useFetcher } from "~/hooks/useFetcher";
import {
  adminArtifactLineagePath,
  artifactLineagePath,
  type ArtifactLineageGraph,
} from "~/services/artifacts";
import type { ArtifactScope } from "./useArtifactPreview";

// Fetches the lineage graph for a single artifact. The endpoint lives on
// analysis-agent (with a TODO to move it to conversations-api), so we hit
// VITE_ANALYSIS_AGENT_API rather than VITE_CONVERSATIONS_API. The renderer
// only ever consumes `mermaid`; the structured node/edge arrays are
// exposed for cases that want to count or filter without parsing the
// diagram.
export function useArtifactLineage(scope: ArtifactScope, artifactId: string) {
  let url: string | null = null;
  if (scope.conversationId) {
    url = scope.isAdmin
      ? adminArtifactLineagePath(scope.conversationId, artifactId)
      : artifactLineagePath(scope.conversationId, artifactId);
  }
  const { data, error, isLoading } = useFetcher<ArtifactLineageGraph>(url);
  return { lineage: data, error, isLoading };
}
